class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-modal-trigger').on('click', function (e) {
      e.preventDefault();
      $('.js-modal').addClass('is-active');
			scrollBanOpen();
    });

    // 閉じる
    $('.js-modal-close, .js-modal-overlay').on('click', function (e) {
      $('.js-modal').removeClass('is-active');
			scrollBanClase();
    });
	}
}
